import FondationsApiModel from '../global/FondationsApiModel';
import { computed }       from 'mobx';

export default class ActivityDomainModel extends FondationsApiModel {
	static get path(): string {
		return '/activity_domains/{?id}';
	}

	@computed
	public get label() {
		return this.get('label');
	}
}
